import React, { useEffect, useState } from 'react';

const API_URL = import.meta.env.VITE_API_URL || window.location.origin;

const DetectionModelSelector: React.FC = () => {
  const [modules, setModules] = useState<Record<string, { is_default: boolean }>>({});
  const [modulesLoading, setModulesLoading] = useState(true);
  const [selectedModule, setSelectedModule] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    const fetchModules = async () => {
      try {
        const healthRes = await fetch(`${API_URL}/api/dashboard/model-health`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (healthRes.ok) {
          const data = await healthRes.json();
          if (data.modules) {
            setModules(data.modules as Record<string, { is_default: boolean }>);
          }
        }
        const moduleRes = await fetch(`${API_URL}/api/dashboard/detection-module`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (moduleRes.ok) {
          const data = await moduleRes.json();
          if (data.module) setSelectedModule(data.module);
        }
      } catch {
        setSelectedModule('');
      } finally {
        setModulesLoading(false);
      }
    };
    fetchModules();
  }, []);

  const handleChange = async (moduleName: string) => {
    setSelectedModule(moduleName);
    setIsSaving(true);
    try {
      const token = localStorage.getItem('auth_token');
      await fetch(`${API_URL}/api/dashboard/detection-module`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ module: moduleName }),
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <select
      value={selectedModule}
      onChange={(e) => handleChange(e.target.value)}
      disabled={isSaving || modulesLoading}
      title="Model used for live camera inference"
      className="px-2.5 py-1.5 border border-gray-300 dark:border-claude-darkBorder rounded-lg text-sm dark:bg-claude-darkBg dark:text-claude-darkText focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
    >
      <option value="none">No detection (off)</option>
      <option value="">Server default</option>
      {Object.keys(modules).length === 0 && !modulesLoading && (
        <option value="" disabled>Model server offline</option>
      )}
      {Object.entries(modules).map(([name, info]) => (
        <option key={name} value={name}>
          {name === 'cat-pose' ? 'cat-pain' : name}{info?.is_default ? ' (default)' : ''}
        </option>
      ))}
    </select>
  );
};

export default DetectionModelSelector;